export function getWeekDates(date: Date = new Date()): Date[] {
  const current = new Date(date);
  const week: Date[] = [];
  
  // Get Monday of current week
  current.setDate(current.getDate() - current.getDay() + (current.getDay() === 0 ? -6 : 1));
  
  // Get all days of the week
  for (let i = 0; i < 7; i++) {
    week.push(new Date(current));
    current.setDate(current.getDate() + 1);
  }
  
  return week;
}

export function formatDate(date: Date): string {
  return date.toLocaleDateString('en-GB', {
    day: 'numeric',
    month: 'short'
  });
}

export function getWeekRange(dates: Date[]): string {
  if (dates.length === 0) return '';
  
  const firstDate = dates[0];
  const lastDate = dates[dates.length - 1];
  
  const isSameMonth = firstDate.getMonth() === lastDate.getMonth();
  const isSameYear = firstDate.getFullYear() === lastDate.getFullYear();
  
  if (isSameMonth && isSameYear) {
    return `${formatDate(firstDate)} - ${lastDate.getDate()}`;
  }
  
  return `${formatDate(firstDate)} - ${formatDate(lastDate)}`;
}
